import { defineAsyncComponent } from 'vue'
export default {
  common: defineAsyncComponent(() => import("/app/layouts/common.vue").then(m => m.default || m))
}